<div id="soft_alert5" class="soft_alert"><p>Hinweis: Die Nutzungsgebühr wird je nach Auswahl im Voraus einmalig für 12
    Monate oder monatlich zum ersten Werktag von Ihrem Konto eingezogen. Angefangene
    Monate werden, sofern nicht anders vereinbart, anteilig berechnet. Die Mandatsreferenz wird Ihnen separat
    mitgeteilt.</p></div>
